import React from 'react';
import { ePermissions } from 'types/administration/userAdministration/ePermissions';
import { SearchBarContainer } from './SearchBarContainer';
import { useHasPermissions } from '../../accessControl/hooks/useHasPermissions';

export interface ISearchBar {}

export const SearchBar: React.FC<ISearchBar> = () => {
  const hasPermission = useHasPermissions([ePermissions.OrderRead]);
  if (!hasPermission) {
    return <></>;
  }

  return <SearchBarContainer />;
};
